/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  Card,
  Col,
  Popover,
  Progress,
  Row,
  Table,
  TableColumnsType,
  Tag,
} from "antd";
import IconRevenue from "../../../../../../atoms/CustomIcons/IconRevenue";
import IconDollarCircle from "../../../../../../atoms/CustomIcons/IconDollarCircle";
import IconDollarSimple from "../../../../../../atoms/CustomIcons/IconDollarSimple";
import IconHourlyRates from "../../../../../../atoms/CustomIcons/IconHourlyRates";

export default function TabDashboard() {
  const content = (
    <div className="popover_content">
      <table className="costing_table_popover">
        <tbody>
          <tr>
            <td>Estimated</td>
            <td>200 hrs</td>
          </tr>
          <tr>
            <td>Actual</td>
            <td>200 hrs</td>
          </tr>
          <tr>
            <td>Efficiency</td>
            <td>
              <Tag className="grey_tag_fill"> 100% </Tag>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );

  const columns: TableColumnsType = [
    {
      title: "Invoice",
      dataIndex: "invoice",
      width: 120,
      fixed: "left",
      render: (text) => (text ? text : "-"),
      sorter: (a, b) => a?.invoice?.localeCompare(b?.invoice),
      ellipsis: true,
    },
    {
      title: "Value",
      dataIndex: "value",
      width: 100,
      render: (text) => (text ? text : "-"),
      sorter: (a, b) => a?.value?.localeCompare(b?.value),
      ellipsis: true,
    },
    {
      title: "Created",
      dataIndex: "created",
      width: 100,
      render: (text) => (text ? text : "-"),
      sorter: (a, b) => a?.created?.localeCompare(b?.created),
      ellipsis: true,
    },
    {
      title: "Due date",
      dataIndex: "due_date",
      width: 100,
      render: (text) => (text ? text : "-"),
      sorter: (a, b) => a?.due_date?.localeCompare(b?.due_date),
      ellipsis: true,
    },
    {
      title: "Status",
      dataIndex: "status",
      width: 100,
      render: (text: string[]) => <Tag className="grey_tag"> {text} </Tag>,
      sorter: (a, b) => a?.status?.localeCompare(b?.status),
      ellipsis: true,
    },
  ];

  const dataSource = [
    {
      key: "1",
      invoice: "001-23-156",
      value: "$ 75,495",
      created: "Sep 1",
      due_date: "Oct 5",
      status: "Pending",
    },
    {
      key: "2",
      invoice: "001-23-156",
      value: "$ 75,495",
      created: "Sep 2",
      due_date: "Oct 5",
      status: "Pending",
    },
    {
      key: "3",
      invoice: "001-23-156",
      value: "$ 75,495",
      created: "Sep 3",
      due_date: "Oct 5",
      status: "Pending",
    },
    {
      key: "4",
      invoice: "001-23-156",
      value: "$ 75,495",
      created: "Sep 4",
      due_date: "Oct 5",
      status: "Pending",
    },
    {
      key: "5",
      invoice: "001-23-156",
      value: "$ 75,495",
      created: "Sep 5",
      due_date: "Oct 5",
      status: "Pending",
    },
  ];

  return (
    <div className="dashboardTabContent">
      <Row gutter={16} wrap={false}>
        <Col span={24}>
          <div className="contract_dashboard_parent">
            <div className="contract_dashboard_col">
              <Card className="contract_dashboard_card">
                <h3>
                  <IconRevenue /> Production efficiency
                </h3>

                <div className="dashboard_row">
                  <div className="dashboard_row_content">
                    <h5 className="dashboard_title">
                      <div> Landscape maintenance </div>
                      <span className="dashboard_subtitle">
                        <span>200 hrs</span>
                        <span className="text_muted">/ 400 hrs</span>
                      </span>
                    </h5>
                    <Progress
                      percent={50}
                      showInfo={false}
                      trailColor="#DEF4F2"
                      strokeColor="#00A08B"
                    />
                  </div>
                  <Popover
                    overlayClassName="project_gm_popover"
                    overlayStyle={{ width: 200 }}
                    content={content}
                    title="To date hrs"
                    arrow={false}
                  >
                    <div className="dashboard_value">
                      50%
                      <span className="dashboard_value_sub">Efficiency</span>
                    </div>
                  </Popover>
                </div>

                <div className="dashboard_row">
                  <div className="dashboard_row_content">
                    <h5 className="dashboard_title">
                      Holiday lighting
                      <span className="dashboard_subtitle">
                        <span>400 hrs</span>
                        <span className="text_muted">/ 600 hrs</span>
                      </span>
                    </h5>
                    <Progress
                      percent={60}
                      showInfo={false}
                      trailColor="#FDE6EE"
                      strokeColor="#F05B8F"
                    />
                  </div>
                  <div className="dashboard_value">
                    67%
                    <span className="dashboard_value_sub">Efficiency</span>
                  </div>
                </div>
              </Card>

              <Card
                className="contract_dashboard_card"
                style={{ marginBottom: "0px" }}
              >
                <h3>
                  <IconDollarSimple /> Profitability overview
                </h3>
                <Table
                  columns={columns}
                  dataSource={dataSource}
                  className="contracts_invoice_table"
                />
              </Card>
            </div>

            <div className="contract_dashboard_col">
              <Card className="contract_dashboard_card">
                <h3>
                  <IconDollarCircle /> Projected gross margin
                </h3>

                <div className="dashboard_row">
                  <div className="dashboard_row_content">
                    <h5 className="dashboard_title">
                      Landscape maintenance
                      <span className="dashboard_subtitle">
                        <span>40%</span>
                        <span className="text_muted">/ 50%</span>
                      </span>
                    </h5>
                    <Progress
                      percent={50}
                      showInfo={false}
                      trailColor="#CCE6F9"
                      strokeColor="#F05B8F"
                    />
                  </div>
                  <div className="dashboard_value">
                    -10%
                    <span className="dashboard_value_sub">Delta</span>
                  </div>
                </div>

                <div className="dashboard_row">
                  <div className="dashboard_row_content">
                    <h5 className="dashboard_title">
                      Holiday lighting
                      <span className="dashboard_subtitle">
                        <span>62%</span>
                        <span className="text_muted">/ 62%</span>
                      </span>
                    </h5>
                    <Progress
                      percent={60}
                      showInfo={false}
                      trailColor="#FFD34C"
                      strokeColor="#56ADEC"
                    />
                  </div>
                  <div className="dashboard_value">
                    0%
                    <span className="dashboard_value_sub">Delta</span>
                  </div>
                </div>
              </Card>

              <Card
                className="contract_dashboard_card"
                style={{ marginBottom: "0px" }}
              >
                <h3>
                  <IconHourlyRates /> Invoices
                </h3>
                <Table
                  columns={columns}
                  dataSource={dataSource}
                  className="contracts_invoice_table"
                />
              </Card>
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
}
